import { getLocalTimeZone, today } from '@internationalized/date';
import { getDefaultCountdownPosition } from '@lib/countdownPosition';
import { DEFAULT_CONFIG } from '@lib/defaultConfig';
import { applyTimerTemplate } from '@lib/timerTemplates';
import { applyCreateTimerType } from '@lib/timerTypes';
import { ConfigData, TimerType } from '@/types';

/** `DEFAULT_CONFIG` is a module-level object, so its collections are copied before a draft starts mutating them. */
export function cloneConfigBase(): ConfigData {
	return {
		...DEFAULT_CONFIG,
		categories: DEFAULT_CONFIG.categories.map((category) => ({ ...category })),
		specificPages: DEFAULT_CONFIG.specificPages.map((page) => ({ ...page })),
		products: DEFAULT_CONFIG.products.map((product) => ({ ...product })),
	};
}

/**
 * A new timer opens with the date range already filled in, so the required field can't be left empty by accident.
 * Both dates are plain calendar days — the same shape `DateRangePicker` produces.
 * The timer type and the template come from the creation wizard; the counter starts where the timer type fits it.
 */
export function buildCreateModeConfig(timerType: TimerType = TimerType.BAR, templateId?: string): ConfigData {
	const rangeStart = today(getLocalTimeZone());
	const config = applyTimerTemplate(
		applyCreateTimerType(cloneConfigBase(), timerType),
		templateId,
		getDefaultCountdownPosition(timerType),
	);

	return {
		...config,
		from_date: rangeStart.toString(),
		to_date: rangeStart.add({ days: 1 }).toString(),
	};
}
